import styled from 'styled-components';

const IABButtonBase = styled.button`
  display: inline-block;
  position: relative;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 1;
  color: #fff;
  border-radius: 30px;
  padding: 19px 20px;
  border: none;
  outline: none;
  cursor: pointer;
  overflow: hidden;
  transition-property: background-color;
  transition-duration: 0.3s;

  &.ButtonMedium {
    line-height: 28px;
    padding: 12px 60px;
  }
`;

export const IABButtonRed = styled(IABButtonBase)`
  background-color: #ff2d38;
  &:hover {
    background-color: #e02531;
  }
`;

export const IABButtonYellow = styled(IABButtonBase)`
  background-color: #fca600;
  &:hover {
    background-color: #db9000;
  }

  &.ButtonMedium {
    font-size: 13px;
    padding: 0 18px;
  }
`;

export const IABHero = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  background-color: #ffeaeb;
  border-radius: 16px;
  padding: 33px 430px 40px 20px;
  min-height: 341px;
  overflow: hidden;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
    padding: 24px;
    min-height: 0;
  }
`;

export const IABHeroTextBlock = styled.div`
  flex: 1 1 auto;
`;

export const IABHeroLabel = styled.div`
  font-size: 24px;
  font-weight: 400;
  line-height: 1.3;
  color: #ff2d38;
  margin-bottom: 12px;
`;

export const IABHeroTitle = styled.h2`
  font-size: 30px;
  font-weight: 800;
  color: #2f3d48;
  line-height: 1.7;
  margin: 0 0 16px 0;
`;

export const IABHeroDescription = styled.p`
  font-size: 14px;
  color: #172751;
  line-height: 1.7;
  margin: 0 0 24px 0;
`;

export const IABHeroIllustration = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 356px;
  height: 341px;
  object-fit: contain;
  @media (max-width: 900px) {
    position: static;
    width: 100%;
    max-width: 356px;
    height: auto;
  }
`;

export const IABSectionTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  color: #2f3d48;
  margin: 32px 0 16px 0;
  &.inGrid {
    grid-column: 1 / -1;
    margin-top: 0;
    margin-bottom: 0px;
  }
`;

export const IABStepGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const IABStepCard = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 22px 107px 18px 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 180px;
  overflow: hidden;
`;

export const IABStepLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  line-height: 1.7;
  color: #17c981;
  margin-bottom: 8px;
`;

export const IABStepTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.7;
  color: #000000;
  margin-bottom: 8px;
`;

export const IABStepDescription = styled.div`
  font-size: 12px;
  color: #000000;
  line-height: 1.7;
`;

export const IABStepIllustration = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100px;
  height: 100px;
  object-fit: contain;
`;

export const IABBenefitGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 24px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 19px 20px 24px;
  margin-top: 32px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const IABBenefitCard = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const IABBenefitIconBox = styled.div`
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  background-color: #e3fff4;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IABBenefitIcon = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
`;

export const IABBenefitTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.7;
  color: #000000;
  margin-top: 6px;
  margin-bottom: 6px;
`;

export const IABBenefitDescription = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #000000;
  line-height: 1;
  margin-bottom: 6px;
`;

export const IABBottomBanner = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background-color: #fff1d5;
  border-radius: 12px;
  padding: 15px 20px 15px 16px;
  margin-top: 24px;
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const IABBottomBannerIcon = styled.img`
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  object-fit: contain;
`;

export const IABBottomBannerTextBlock = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;

export const IABBottomBannerTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  color: #2f3d48;
`;

export const IABBottomBannerText = styled.div`
  font-size: 14px;
  line-height: 1;
  color: #2f3d48;
  margin-top: 4px;
`;
